<script>
	import { mobileMenuOpened } from "/src/store.js"
	import { t, locale } from '$lib/translations';

	export let navLinks;
</script>

<div class="mobile-menu" class:opened={$mobileMenuOpened}>
	<div class="mobile-links">
		<ul>
			{#if navLinks && navLinks.length > 0}
				{#each ($locale === 'ua' ? navLinks : navLinks.slice(0, 4)) as link }
					<li><a href="{link.endpoint}" on:click={() => mobileMenuOpened.set(false)}>{link.name}</a></li>
				{/each}
			{/if}
			<li><a href="/{$locale}/donate" on:click={() => mobileMenuOpened.set(false)}>{$t('header.donate')}</a></li>
		</ul>
	</div>
</div>

<style lang="scss">

	.mobile-menu {
        position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		height: 100%;
		background-color: black;
		transform: translateX(-100%);
		transition: transform 0.5s;
		z-index: 1;

		& > .mobile-links {
			display: flex;
			justify-content: center;
			margin-top: 6rem;

			& > ul {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 30px;
				list-style-type: none;

				& > li {

					& > a {
						color: #FFFBEF;
						text-decoration: none;
						font-weight: 300;
						font-size: 20pt;
					}
				}
			}
		}

		&.opened {
			transform: translateX(0);
		}
	}
</style>